import { render, staticRenderFns } from "./ShoppingListDemo.vue?vue&type=template&id=622153b8&"
import script from "./ShoppingListDemo.vue?vue&type=script&lang=ts&"
export * from "./ShoppingListDemo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports